export const plId = "elfsight-app-578970dd-5d2d-4c85-98db-cfbb009f515c";
export const rusId = "elfsight-app-16ac3083-a7d7-434a-9fa6-b6ce26a8eeda";
